'use client'

import { cn } from '@/lib/utils'

export type ShareRoomEmailPreviewPanelProps = {
  html: string
  /** e.g. "Email preview" vs "Invitation preview" */
  heading: string
  className?: string
}

export function ShareRoomEmailPreviewPanel({
  html,
  heading,
  className,
}: ShareRoomEmailPreviewPanelProps) {
  return (
    <div
      className={cn(
        'min-w-0 flex-[1.25] border-l border-gray-200 pl-6 lg:pl-8 mt-4 md:mt-0 max-h-[min(680px,78vh)] overflow-y-auto',
        className
      )}
    >
      <h3 className="mb-2 text-sm font-medium text-gray-500">{heading}</h3>
      <iframe
        title="Invitation email preview"
        className="mt-4 h-[min(620px,72vh)] w-full rounded-lg border border-slate-200 bg-white shadow-sm"
        sandbox="allow-same-origin"
        srcDoc={html}
      />
    </div>
  )
}
